export const PREPARING_FILE_MESSAGE = 'Preparando tu archivo...';
export const PREPARE_FILE_ERROR_MESSAGE = 'No pudimos preparar tu archivo. Inténtalo de nuevo.';
export const CERTIFICATE_UNAVAILABLE_MESSAGE =
  'No pudimos generar tu certificado. Escríbenos por WhatsApp y lo revisamos contigo.';
export const UPDATE_APP_TO_DOWNLOAD_MESSAGE = 'Actualiza tu app para descargar este archivo.';
